<template>
	<modal ref="modal" :title="title" :close_on_focus="false" :no_overflow="true" style="min-width: 455px">
		<div class="form-group row">
			<div class="col-12">
				<label for="form-name">Name</label>
				<input id="form-name" type="text" class="form-control main-modal--input" v-model="form_name">
			</div>
		</div>
		<div class="form-group row">
			<div v-if="!saving" class="col-12 text-right">
				<button class="btn btn-secondary px-2" v-on:click="cancel()">Cancel</button>
				<button class="btn btn-primary px-2 ml-2" v-on:click="save()">Save</button>
			</div>
			<loader v-else></loader>
		</div>
	</modal>
</template>

<script>
	import Modal from "../general_components/Modal";
	import Loader from "../general_components/Loader";
	export default {
		name: "CloneFormModal",
		components: {Loader, Modal},
		props: {
			clone_url: {
				type: String,
				required: true
			},
			company_form: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				form_id: null,
				form_instance_id: null,
				form_name: null,
				original_name: null,

				saving: false,
			}
		},

		methods: {
			open(form) {
				if (this.company_form){
					this.form_id = form.id;
					this.form_name = 'Copy of ' + form.name;
					this.original_name = form.name;
				}
				else {
					this.form_instance_id = form.id;
					this.form_name = 'Copy of ' + form.form.name;
					this.original_name = form.form.name;
				}

				this.$nextTick(function () {
					this.$refs.modal.openModal();
				})
			},

			cancel() {
				this.$refs.modal.closeModal(null, true);

				this.form_id = null;
				this.form_instance_id = null;
				this.form_name = null;
				this.original_name = null;
			},

			save(){
				if (this.saving) return;

				this.saving = true;
				axios.post(this.clone_url.replace('?', this.company_form ? this.form_id : this.form_instance_id), {
					name: this.form_name
				})
					.then(() => {
						window.location.reload();
					})
					.catch(() => {
                        Vue.$toast.open({
                            message: 'Something went wrong',
                            type: 'error'
                        });
					})
			}
		},

		computed: {
			title(){
				return 'Duplicate ' + (this.original_name ? this.original_name : 'form');
			}
		}
	}
</script>
